import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import i18n from "../../../i18next";

import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';
import { loadCustomerInsightOrderSearchSummary } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { loadRestaurantInsightOrderSearchSummary } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";

class OrderTypeSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;

        if(this.props.insightType ==='restaurant') {
            this.props.loadRestaurantInsightOrderSearchSummary(restaurantId, this.state.fromDate, this.state.toDate);
        } else {
            this.props.loadCustomerInsightOrderSearchSummary(restaurantId, customerId, this.state.fromDate, this.state.toDate);
        } 
    }

    takeSearchOptionState = searchOptionState => {

        if(this.props.insightType ==='restaurant') {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
    
            const { restaurantId, customerId } = this.props;
            this.props.loadRestaurantInsightOrderSearchSummary(restaurantId, searchOptionState.fromDate, searchOptionState.toDate);
        } else {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
    
            const { restaurantId, customerId } = this.props;
            this.props.loadCustomerInsightOrderSearchSummary(restaurantId, customerId, searchOptionState.fromDate, searchOptionState.toDate);
        }
    }

    renderOrderTypeTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '5px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.orderType')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.count')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalSpent')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.tip')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.deposit')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.deliveryFee')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.serviceFee')}</th>
                {this.props.insightType === 'restaurant' && <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:restaurantInsightScreen.giftCardTotal')}</th>}
            </tr>
        );
    }

    renderTableContent = () => {
        if(this.props.insightType === 'restaurant' && this.props.restaurantInsightOrderTypes) {
            return  this.props.restaurantInsightOrderTypes.map(item => {
                return this.renderSingleItem(item);
            })
        } else {
            return this.props.customerInsightOrderTypes.map(item => {
                return this.renderSingleItem(item);
            })
        }
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;
        
        return (
            <tr>
                <td style={{ ...tableDetail }}>{this.renderOrderSVGIcon(item.typeOrName)}&nbsp;&nbsp;{this.renderOrderTypeName(item.typeOrName)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.count}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.totalSpent, currency)}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.tip, currency)}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.deposit, currency)}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.deliveryFee, currency)}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.serviceFee, currency)}</td>
                {this.props.insightType === 'restaurant' && <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.giftCardTotal, currency)}</td>}
            </tr>
        );
    }

    renderOrderSVGIcon = type => {
        switch (type) {
            case "Delivery": return <DeliverySVG width={16} height={16} fill={'#0288D1'} />;
            case "PickUp": return <PickUpSVG width={16} height={16} fill={'#0288D1'} />
            case "Curbside": return <CurbsideSVG width={16} height={16} fill={'#0288D1'} />
            case "Dine In": return <InStoreSvg width={16} height={16} fill={'#0288D1'} />
            default: return null
        }
    }

    renderOrderTypeName = type => {
        switch (type) {
            case "Delivery": return i18n.t('screens:customerInsightScreen.Delivery');
            case "PickUp": return i18n.t('screens:customerInsightScreen.Collection');
            case "Curbside": return i18n.t('screens:customerInsightScreen.Curbside');
            case "Dine In": return i18n.t(`screens:restaurantsMainContainer.instore`);
            default: return null
        }
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="OrderTypes" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderOrderTypeTable()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightOrderTypes: state.customerInsightOrderTypes,
        restaurantInsightOrderTypes: state.restaurantInsight.orderTypeSummary,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadCustomerInsightOrderSearchSummary,
    loadRestaurantInsightOrderSearchSummary })(OrderTypeSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/OrderTypeSearch.js